/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC91c2VyLW1hbmFnZW1lbnQvdXNlci1wYXlyb2xsLWJpbGxpbmcvdXNlci1wYXlyb2xsLWJpbGxpbmcuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvdXNlci1tYW5hZ2VtZW50L3VzZXItcGF5cm9sbC1iaWxsaW5nL3VzZXItcGF5cm9sbC1iaWxsaW5nLmNvbXBvbmVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/user-payroll-billing/user-payroll-billing.component.css.shim.ngstyle.ts